import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

const LoadMoreButton = ({ moreResults, loadMoreClick, loading, classes }) => {
  if (moreResults) {
    return (
      <Button
        classes={`load-more-btn pos-relative w-100 d-block border-1 border-color-grey--light bg-grey--lightest link link--tertiary fw-medium p-a-3 align-text-center ${classes}`}
        onClick={loadMoreClick}
        loading={loading}
        spinColor="black"
        faux
      >
        Load more
      </Button>
    );
  }

  return null;
};

LoadMoreButton.propTypes = {
  moreResults: PropTypes.bool,
  loadMoreClick: PropTypes.func,
  loading: PropTypes.bool,
  classes: PropTypes.string,
};

export default LoadMoreButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/LoadMoreButton.js